import React, { useEffect } from 'react';
import '../styles/11xplay.css'; 

const ElevenXPlayPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  return (
    <div className="elevenxplay-page">
  <div className='header'>
    <h1>Welcome to <span className='highlight'>11xplay:</span> Your Ultimate Platform for <span className='highlight'>Online Betting</span></h1>
    <img src="/11xplay.webp" alt="11xplay Logo" className="logo" />
  </div>

  <section className="intro">
    <p>
      Ready to elevate your online betting adventure? <span className='highlight'>11xplay</span> is your gateway to a world of excitement, offering thrilling games and big wins, handpicked by <span className='highlight'>Reddy Anna</span>. Whether you're an experienced player or a newcomer, we provide everything you need to make your betting experience unforgettable.
    </p>
    <div className="cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Contact Us Now
      </a>
    </div>
  </section>

  <section className="why-choose">
    <h2>Why Choose <span className='highlight'>11xplay</span>?</h2>
    <ol>
      <li>
        <strong>Diverse Game Selection:</strong> Immerse yourself in a wide variety of casino games offering endless entertainment and huge winning potential, curated by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>Live Betting Action:</strong> Feel the adrenaline rush with live sports betting on games like <span className='highlight'>Andar Bahar, Teen Patti, Baccarat</span>, and more, all guided by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>Multiple Payment Options:</strong> Easily fund your account and withdraw winnings using safe payment methods such as <span className='highlight'>UPI, Credit Card, Debit Card, and Net Banking</span>.
      </li>
      <li>
        <strong>24/7 Support:</strong> Our dedicated support team, managed by <span className='highlight'>Reddy Anna</span>, is available round the clock to assist you with all your betting needs.
      </li>
    </ol>
    <div className="cta-buttons">
      <a href="https://wa.me/916666039778" className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href="https://wa.me/918440000562" className="contactus-button" target="_blank" rel="noopener noreferrer">
        Contact Us Now
      </a>
    </div>
  </section>

  <section className="features">
    <h2><span className='highlight'>Key Features</span> of <span className='highlight'>11xplay</span></h2>
    <ol>
      <li>
        <strong>Quick Deposits & Withdrawals:</strong> Enjoy fast and easy transactions that keep you in the action, recommended by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>Live Streaming:</strong> Watch your favorite events live with our real-time streaming feature, bringing the excitement directly to your screen, curated by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>High Payout Odds:</strong> Increase your chances of winning big with competitive odds across all major sports including <span className='highlight'>Cricket, Football, Tennis</span>, and more, handpicked by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>Global Casino Games:</strong> Enjoy international classics such as <span className='highlight'>Baccarat, Roulette, and Blackjack</span>, all carefully selected by <span className='highlight'>Reddy Anna</span>.
      </li>
    </ol>
  </section>

  <section className="getting-started">
    <h2>Getting Started with <span className='highlight'>11xplay</span></h2>
    <ol>
      <li>
        <strong>Contact via WhatsApp:</strong> Initiate a conversation through WhatsApp to request your unique 11xplay ID, guided by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>Submit Your Information:</strong> Provide the necessary details like name, phone number, email, and preferred password to get started, as directed by <span className='highlight'>Reddy Anna</span>.
      </li>
      <li>
        <strong>Start Betting:</strong> After receiving your personalized 11xplay.com ID, begin your betting journey with access to a world of exciting games and big wins.
      </li>
    </ol>
    <div className="cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Contact Us Now
      </a>
    </div>
  </section>

  <section className="security">
    <h2><span className='highlight'>Privacy</span> and <span className='highlight'>Security</span> at <span className='highlight'>11xplay</span></h2>
    <p>
      Your privacy and security are our top priorities. With advanced encryption technologies like SSL, we ensure your personal information remains fully protected, with the endorsement of <span className='highlight'>Reddy Anna</span>.
    </p>
    <p>
      Join <span className='highlight'>11xplay</span> today to enjoy an exhilarating betting experience, featuring unmatched excitement, continuous fun, and the opportunity to win substantial rewards, all guided by <span className='highlight'>Reddy Anna</span>. Your adventure starts now – sign up today!
    </p>
    <div className="cta-buttons">
      <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Open Your Demo Account
      </a>
      <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
        Contact Us Now
      </a>
    </div>
  </section>
</div>

  );
};

export default ElevenXPlayPage;
